import { Grid } from '@mui/material';
import ContactInfoCard from './Components/ContactInfoCard';
import ActivityCard from './Components/ActivityCard';
import { useParams } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { contactQueryOptions } from '@utils/queryOptions';

const ContactOverview = ({}) => {
    const { contactId } = useParams({});
    const { data: contact } = useSuspenseQuery(contactQueryOptions(contactId));

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <ContactInfoCard contact={contact} />
            </Grid>
            <Grid item xs={12} md={8}>
                <ActivityCard />
            </Grid>
        </Grid>
    );
};

export default ContactOverview;
